const paypalConstants = {
  PAYPAL_FLOW_STARTED: "PAYPAL_FLOW_STARTED",
  PAYPAL_API_STARTED: "PAYPAL_API_STARTED",
  PAYPAL_API_SUCCESS: "PAYPAL_API_SUCCESS",
  PAYPAL_API_FAILED: "PAYPAL_API_FAILED",
  PAYPAL_EXPRESS_CHECKOUT_POST_SUCCESS: "PAYPAL_EXPRESS_CHECKOUT_POST_SUCCESS",
  PAYPAL_EXPRESS_CHECKOUT_GET_SUCCESS: "PAYPAL_EXPRESS_CHECKOUT_GET_SUCCESS",
  PAYPAL_EXPRESS_CHECKOUT_DELETE_SUCCESS:
    "PAYPAL_EXPRESS_CHECKOUT_DELETE_SUCCESS",
  PAYPAL_EXPRESS_CHECKOUT_FAIL: "PAYPAL_EXPRESS_CHECKOUT_FAIL",
  PAYPAL_EXPRESS_CHECKOUT_ERROR: "PAYPAL_EXPRESS_CHECKOUT_ERROR",
  PAYPAL_EXPRESS_CHECKOUT_CANCEL: "PAYPAL_EXPRESS_CHECKOUT_CANCEL",
}

export default paypalConstants
